import {
  CreateAnnouncementDto,
  CreatePrefilledFlixcheckUrlDto,
  IAnnouncement,
  IFlixcheckCheck,
  IMakeComWebhook,
  IN8NWebhook,
} from 'admiral-core';
import { AxiosResponse } from 'axios';
import { AdmiralApi, BASE_URL } from '@/services/AdmiralApi';

export class N8nApi {
  static async saveWebhook(webhookUrl: string, apiKey: string): Promise<AxiosResponse<string>> {
    return AdmiralApi.apiCall<string>({
      method: 'POST',
      url: `${BASE_URL}/integrations/n8n/save-webhook`,
      data: { webhookUrl, apiKey },
    });
  }

  static async getWebhook(): Promise<AxiosResponse<IN8NWebhook>> {
    return AdmiralApi.apiCall<IN8NWebhook>({
      method: 'POST',
      url: `${BASE_URL}/integrations/n8n/get-webhook`,
    });
  }
}
